import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => {
	return {
		fieldContainer: {
			maxWidth: 576,
			width: "100%",
			[theme.breakpoints.down("sm")]: {
				maxWidth: "100%",
			},
		},
		// MAX-3878: spacing between the Description field and the Category select below it.
		descriptionField: {
			marginBottom: 24,
		},
		// MAX-4201: required marker on the Market source while it has no Market.
		requiredAsterisk: {
			color: theme.palette.error.main,
		},
		section: {
			background: baseColors.white,
			border: `1px solid ${baseColors.gray100}`,
			borderRadius: 8,
			padding: 16,
			marginBottom: 16,
			display: "flex",
			flexDirection: "column",
		},
	} satisfies Record<string, CSSObject>;
};
